export default function selectAdProduct(adProducts = [], randNum) {
  return adProducts.find(
    (adProduct) =>
      adProduct.sovLowerRange <= randNum && adProduct.sovUpperRange >= randNum,
  );
}
